import { useTranslation } from 'react-i18next';

import { AllBeneficiaries } from '@/features/beneficiaries/components/AllBeneficiaries/AllBeneficiaries';
import { Page } from '@/ui-kit/templates/Page';

export function BeneficiariesPage() {
  const { t } = useTranslation();
  return (
    <Page title={t('layout.sidebar.links.beneficiaries')}>
      <AllBeneficiaries />
    </Page>
  );
}
